import { initializeSvgIcons } from "./SvgIconUtilities";
import { PlannerIconName } from "./PlannerIconName";
import { PlannerIcons } from "./icons";
/**
 * Type-safe access of the icon names of this set, with the registration of the iconSet as a side effect
 *
 * @param name property name of PlannerIconName
 */ export const getPlannerIconName = PlannerIconName;
/**
 * Side effect to register the icon set when this file is referenced, such as when the type-safe functions are used
 */ initializeSvgIcons(PlannerIcons);
